// The scope's findings pool as the Reviews lens's tabs read it: families
// (conduct types) with their incidents, each incident with its member
// findings, every finding by id, and the severity order the lists share.
import { citationsOf, NIL_ID } from "./findingCitations.js";

export const SEVERITY_RANK = { critical: 4, high: 3, medium: 2, low: 1 };
const str = (v) => (v == null ? "" : String(v));

// The pool's grouping: families (conduct types) with their incidents, each
// incident with its member findings, every finding by id. Built from
// conductBySession's result.
export function buildTriageMap(conduct) {
    const families = [];
    const incidents = [];
    const findings = new Map();
    for (const t of conduct?.types || []) {
        const family = {
            index: t.index, name: t.name, sessions: [...t.sessions], findings: t.findings, worst: t.worst,
            wordings: [...new Set(t.incidents.flatMap((i) => i.titles))], incidentIds: [], kin: [...(t.kin || [])],
        };
        for (const inc of t.incidents) {
            const first = inc.members[0];
            const id = `i:${str(first?.finding_id) || `${inc.session}:${incidents.length}`}`;
            const findingIds = inc.members.map((m) => str(m.finding_id)).filter(Boolean);
            incidents.push({ id, session: inc.session, family: family.index, count: inc.count, titles: inc.titles, worst: inc.worst, latestAt: inc.latestAt, findingIds });
            family.incidentIds.push(id);
            for (const m of inc.members) {
                const fid = str(m.finding_id);
                if (!fid) continue;
                const endpoint = str(m.endpoint_id).trim().toLowerCase();
                findings.set(fid, {
                    id: fid, session: inc.session, endpoint: endpoint && endpoint !== NIL_ID ? endpoint : null,
                    title: str(m.title), severity: str(m.behaviour_severity).toLowerCase(), category: str(m.behaviour_category),
                    quotes: Array.isArray(m.citation_quotes) ? m.citation_quotes : [], completedAt: str(m.completed_at),
                    messages: (Array.isArray(m.citation_message_ids) ? m.citation_message_ids : []).map((x) => str(x).toLowerCase()).filter(Boolean),
                    citations: citationsOf(m),
                    family: family.index, incident: id,
                });
            }
        }
        families.push(family);
    }
    return {
        families, incidents, findings,
        familyByIndex: new Map(families.map((f) => [f.index, f])),
        incidentById: new Map(incidents.map((i) => [i.id, i])),
    };
}
